import { signal, effect } from '@preact/signals';
import { secureStorage } from '../storage/secureStorage.js';

export type AudioStyle = 'plain' | 'dramatized';

export type PlayerSettings = {
  rate: number;
  audioStyle: AudioStyle;
};

export const PLAYBACK_RATES = [2, 1.75, 1.5, 1.25, 1] as const;

const DEFAULTS: PlayerSettings = { rate: 1, audioStyle: 'dramatized' };
const STORAGE_KEY = '_ps1';

function load(): PlayerSettings {
  if (typeof localStorage === 'undefined') return DEFAULTS;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULTS;
    const parsed = JSON.parse(raw) as Partial<PlayerSettings>;
    const rate =
      typeof parsed.rate === 'number' && (PLAYBACK_RATES as readonly number[]).includes(parsed.rate)
        ? parsed.rate
        : DEFAULTS.rate;
    const audioStyle: AudioStyle =
      parsed.audioStyle === 'plain' || parsed.audioStyle === 'dramatized'
        ? parsed.audioStyle
        : DEFAULTS.audioStyle;
    return { rate, audioStyle };
  } catch {
    return DEFAULTS;
  }
}

export const playerSettings = signal<PlayerSettings>(load());

if (typeof window !== 'undefined') {
  effect(() => {
    void secureStorage.setItem(STORAGE_KEY, JSON.stringify(playerSettings.value));
  });
}

export function setRate(rate: number): void {
  playerSettings.value = { ...playerSettings.value, rate };
}

export function setAudioStyle(audioStyle: AudioStyle): void {
  playerSettings.value = { ...playerSettings.value, audioStyle };
}
